
import React, {useEffect, useState} from 'react';


import {connect} from 'react-redux';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';

import {customcreartuvj1_676339f09ccea34376cf813a } from '../../api/formulariocontactanos3lmag.api'

import './homepageinevenj9lfi.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    




const Phomepageinevenj9lfi = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {


useEffect(() => {
		const loftyHandleData = async () => {
		}
		loftyHandleData();
	}, []);


  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id6750d00b1de4874021c12cfd" >

      <div id="iw4j" className="">
      
      <div id="ips2" className="">
      
      <div id="itmdc" className="">
      
      <a
        target=""
        className=""
        id="i2aqf"
        href="/"
        type="button"
      >
        
    <div id="i2g1w" className="">
    <span>Inicio</span>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="iwu1w"
        href="/sobrenosotros"
        type="button"
      >
        
    <div id="ib1qi" className="">
    <span>Sobre Nosotros</span>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="i31ek"
        href="/servicios"
        type="button"
      >
        
    <div id="ipu5h" className="">
    <span>Servicios</span>
    </div>
    
      </a>
      
      </div>
      
      <div
        id="iflk8f"
        className=""
        data-aos="zoom-out-down"
        data-aos-duration="1500"
      >
      
      <img
        className=""
        id="ismeq"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4afizry.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iacot" className="">
      
      <a
        target=""
        className=""
        id="i2hsg"
        href="/contrata"
        type="button"
      >
        
    <div id="ij3vk" className="">
    <span>Contrata</span>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="im06bc"
        href="/contacto"
        type="button"
      >
        
    <div id="ifflju" className="">
    <span>Contacto</span>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="ixxmu"
        href="/proveedores"
        type="button"
      >
        
    <div id="ikc1x" className="">
    <span>Proveedores</span>
    </div>
    
      </a>
      
      </div>
      
      <div id="icq3pj" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <span>Inicio</span>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/sobrenosotros"
        type=""
      >
        <span>Sobre Nosotros</span>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/servicios"
        type=""
      >
        <span>Servicios</span>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <span>Contrata</span>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <span>Contacto</span>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <span>Proveedores</span>
      </a>
      
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i17hyw" className="">
      
      </div>
      
      <div
        id="irmuef"
        className=""
        data-aos="fade-up"
        data-aos-duration="2000"
      >
      
      <div id="ihk8" className="">
      
      <img
        className=""
        id="iz9d4"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4afoyqq.png"
        alt="undefined"
      />
      
      <div id="it6xg" className="">
      
      <div id="i08k94" className="">
      
      <div id="ih44fc" className="">
      
      </div>
      
      <p className="" id="i803s">
        <span>Eventos Inolvidables</span>
      </p>
      
      </div>
      
      <p className="" id="ip3sl">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="igr24h">
        <span>EXPERIENCIAS MEMORABLES EN TU VIDA</span>
      </span>
      
      </p>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ikimti" className="">
      
      </div>
      
      <div id="i6xx" className="">
      
      <div id="ia9qpl" className="">
      
      <div
        id="i0vi7e"
        className=""
        data-aos="fade-right"
        data-aos-duration="2000"
      >
      
      <div id="i6gfp7" className="">
      
      <div id="i4qa9x" className="">
      
      </div>
      
      <p className="" id="igqyi">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ipd5db">
        <span>EVENTOS QUE TRASCIENDEN LO ORDINARIO</span>
      </span>
      
      </p>
      
      <img
        className=""
        id="iw6yh"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4bj5v2t.png"
        alt="undefined"
      />
      
      <p className="" id="ij79rj">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i2eapi">
        <span>Estamos aquí para convertir tus visiones en realidad.</span>
      </span>
      
      </p>
      
      </div>
      
      </div>
      
      <div id="i0tfl" className="">
      
      <div
        id="i6vwz5"
        className=""
        data-aos="zoom-in-up"
        data-aos-duration="2500"
      >
      
      <div id="ipv0e6" className="">
      
      </div>
      
      <p className="" id="ioeexc">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="izj7sm">
        <span>Eventos Que Trascienden Lo Ordinario</span>
      </span>
      
      </p>
      
      </div>
      
      <div
        id="iva6bg"
        className=""
        data-aos="zoom-in-up"
        data-aos-duration="2500"
      >
      
      <p className="" id="iyf5qv">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i89s1s">
        <span>Estamos aquí para convertir tus visiones en realidad.</span>
      <br className="" id="" />
      
      </span>
      
      </p>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iewxkl" className="">
      
      </div>
      
      <div id="i3dh" className="">
      
      <div
        id="inugwi"
        className=""
        data-aos="zoom-in-down"
        data-aos-duration="3000"
      >
      
      <div id="iehknh" className="">
      
      <div id="ih9fu9" className="">
      
      </div>
      
      <p className="" id="ijh55q">
        <span>NUESTROS SERVICIOS</span>
      </p>
      
      </div>
      
      </div>
      
      <div id="ihp5j" className="">
      
      <div
        id="imhste"
        className=""
        data-aos="zoom-in-right"
        data-aos-duration="3000"
      >
      
      <div id="ineai6" className="">
      
      <div id="it2aph" className="">
      
      <div id="i4qt8h" className="">
      
      <div id="ijelaw" className="">
      
      </div>
      
      <p className="" id="idjbie">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ikg4vy">
        <span>Creando Unión Inolvidable</span>
      </span>
      
      </p>
      
      </div>
      
      <p className="" id="in8iyv">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ib9s3g">
        <span>Bodas de Ensueño</span>
      </span>
      
      </p>
      
      <p className="" id="iyi33">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ijvtvp">
        <span>Imagina tu boda perfecta y permítenos encargarnos de todo. Desde elegir el lugar ideal hasta coordinar el día del evento, cuidamos cada detalle para que tu día sea una verdadera expresión de tu amor y compromiso.</span>
      </span>
      
      </p>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="idydx" className="">
      
      <img
        className=""
        id="ilqcl"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4bjk4e8.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iomb2h" className="">
      
      </div>
      
      <div id="i7qj2" className="">
      
      <div
        id="itakbi"
        className=""
        data-aos="zoom-out-down"
        data-aos-duration="3000"
      >
      
      <div id="ipkjvh" className="">
      
      <div id="i4xrpl" className="">
      
      </div>
      
      <p className="" id="ijvlce">
        <span>HAZLO TU MISMO</span>
      <br className="" id="" />
      
      </p>
      
      </div>
      
      </div>
      
      <div id="i2jmuj" className="">
      
      <div
        id="iksfqg"
        className=""
        data-aos="zoom-out-right"
        data-aos-duration="3000"
      >
      
      <div id="iiiah3" className="">
      
      <div id="ihqnij" className="">
      
      <p className="" id="ia8tsx">
        
      <span className="" id="it191z">
        <span>Explora Nuestra Plataforma</span>
      </span>
      
      </p>
      
      <p className="" id="izsr7w">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ijd1et">
        <span>Explora nuestra plataforma en busca de inspiración y proveedores. Navega a través de amplios servicios.</span>
      </span>
      
      </p>
      
        <a
          target=""
          className="boton_con_link "
          id="ihsi8b"
          href="#"
        >
          
    <div id="i594rf" className="">
    <span>Comenzar</span>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      <div id="idflb1" className="">
      
      <img
        className=""
        id="iix7qu"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4bkdt5s.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div id="icc7rh" className="">
      
      <div id="i0uxnh" className="">
      
      <img
        className=""
        id="ih1zov"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4bkdt5s.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="ijzo8v" className="">
      
      <div id="ikc7mw" className="">
      
      <p className="" id="it4gqh">
        
      <span className="" id="ihzqfe">
        <span>Explora Nuestra Plataforma</span>
      </span>
      
      </p>
      
      <p className="" id="iaiv9a">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i13t5u">
        <span>Explora nuestra plataforma en busca de inspiración y proveedores. Navega a través de amplios servicios.</span>
      </span>
      
      </p>
      
        <a
          target=""
          className="boton_con_link "
          id="i30dcj"
          href="#"
        >
          
    <div id="iyph3g" className="">
    <span>Comenzar</span>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i42ker" className="">
      
      </div>
      
      <div id="i3m0i" className="">
      
      <div id="ieaixt" className="">
      
      <div id="i2mmhd" className="">
      
      <div id="ire062" className="">
      
      </div>
      
      <p className="" id="i941lv">
        <span>PLANIFICAMOS POR TI</span>
      </p>
      
      </div>
      
      <div id="ieb3g6" className="">
      
      <img
        className=""
        id="imd6yg"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4bkltkq.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="inyrjv"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4bn0qnz.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i73fut" className="">
      
      </div>
      
      <div id="izdkrq" className="">
      
      <div id="izj0ue" className="">
      
      <p className="" id="iucktz">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iiia3x">
        <span>Clientes De INEVEN</span>
      </span>
      
      </p>
      
      </div>
      
      <div id="iou2cz" className="">
      
      <div id="i6wf3u" className="">
      
      <p className="" id="ira3vu">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ig06lb">
        <span>¡Mi boda fue excepcional, Completamente inolvidable!.</span>
      </span>
      
      </p>
      
      <div id="ihkt15" className="">
      
      </div>
      
      <p className="" id="ikaobm">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iv03i5">
        <span>Linda de Escoto</span>
      </span>
      
      </p>
      
      </div>
      
      <div id="iqpteu" className="">
      
      <img
        className=""
        id="iib6bz"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4bkzl2z.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iop8ua" className="">
      
      </div>
      
      <div id="iuo301" className="">
      
      <div id="i1i23v" className="">
      
      <div id="ismuwn" className="">
      
      <div id="if1rq8" className="">
      
      <p className="" id="ixkf85">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i0h1q1">
        <span>SE PARTE DE INEVEN</span>
      </span>
      
      </p>
      
      <div id="ijxxet" className="">
      
      </div>
      
      </div>
      
      <p className="" id="i0bmv5">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i6bl5o">
        <span>Valoramos la pasión, la creatividad y el compromiso con la excelencia en cada detalle.</span>
      </span>
      
      </p>
      
      <p className="" id="ieav2y">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ijuhnq">
        <span>Si eres un proveedor de servicios en el emocionante mundo de los eventos, te invitamos a unirte a nuestra plataforma y ser parte de momentos inolvidables.</span>
      </span>
      
      </p>
      
        <a
          target=""
          className=""
          id="i1zskf"
          href="#"
        >
          
    <div id="in1xgk" className="">
    <span>Conoce más</span>
    </div>
    
        </a>
        
      </div>
      
      <div id="ibc2ox" className="">
      
      <div id="io8xkf" className="">
      
      <img
        className=""
        id="ifpkpl"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4bl5eaz.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="i32q4g" className="">
      
      <img
        className=""
        id="il93ru"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4bl89a9.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ir8mvk" className="">
      
      </div>
      
      <div id="i77v6s" className="">
      
      <div id="if97n2" className="">
      
      <div id="izk83x" className="">
      
      <p className="" id="i9qn2o">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ii6a9l">
        <span>Comienza Tu Historia con Ineven</span>
      </span>
      
      </p>
      
      </div>
      
      <div id="ix6ot6" className="">
      
      <div id="ikpatl" className="">
      
      <p className="" id="i5ebvf">
        
      <span className="" id="iadw7j">
        <span>¡Estamos emocionados por unirnos a ti en esta historia creativa!.</span>
      </span>
      
      </p>
      
      </div>
      
      <div id="iy4b1t" className="">
      
      <p className="" id="ibk1gk">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i3jwtc">
        <span>Cuéntanos tus ideas</span>
      </span>
      
      </p>
      
      <div id="i1p2yy" className="">
      <span>Ingresa tus datos</span>
      </div>
      
        <div className="" id="ikjow3">
          
      <form
        id="iu2eoi"
        className=""
        onSubmit={async (e) => {
				e.preventDefault();
				try {
						const lofty_response = await customcreartuvj1_676339f09ccea34376cf813a({
						nombreo31bw: e.target.nombreo31bw.value,
						telefono71bhf: e.target.telefono71bhf.value,
						correov6gp1l: e.target.correov6gp1l.value,
						cuentanostuideakfptok: e.target.cuentanostuideakfptok.value,
					});
					alert("Se agregó exitosamente");
		} catch (error) {
					console.log(error);
				}
			}}
		
      >
        
      <div id="i1mrms" className="">
      
      <br className="" id="" />
      
      <input
        name="nombreo31bw"
        type="text"
        placeholder="Nombre"
        className="camposFormulario "
        id="i3vlwy"
      />
      
      </div>
      
      <div id="ic1019" className="">
      
      <br className="" id="" />
      
      <input
        name="telefono71bhf"
        type="text"
        placeholder="Telefono"
        className="camposFormulario "
        id="isu5fi"
      />
      
      </div>
      
      <div id="iqbfsl" className="">
      
      <br className="" id="" />
      
      <input
        name="correov6gp1l"
        type="text"
        placeholder="Correo"
        className="camposFormulario "
        id="i0egwv"
      />
      
      </div>
      
      <div id="iyyi8j" className="">
      
      <br className="" id="" />
      
      <input
        name="cuentanostuideakfptok"
        type="text"
        placeholder="Cuentanos tu Idea"
        className="camposFormulario "
        id="ij7rby"
      />
      
      </div>
      
      <button
        type="submit"
        name=""
        id="ipjk1f"
        className=""
        
      >
      
      <div id="iuc0vb" className="">
      <span>Enviar</span>
      </div>
      
      </button>
      
      </form>
      
      <div id="i42a5i" className="">
      
      <p className="" id="icotax">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ix6ahl">
        <span>¿Eres proveedor?</span>
      </span>
      
      </p>
      
        <a
          target=""
          className=""
          id="ikv69v"
          href="#"
        >
          
    <div id="i66nrd" className="">
    <span>Encuentra</span>
    </div>
    
        </a>
        
      <p className="" id="iy0oit">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ikszcj">
        <span>nuevos clientes</span>
      </span>
      
      </p>
      
      </div>
      
        </div>
        
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="is15sj" className="">
      
      </div>
      
      <div id="icohi" className="">
      
      <div id="iyghfd" className="">
      
      <div id="i52pnr" className="">
      
      <img
        className=""
        id="imi9j3"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4afizry.png"
        alt="undefined"
      />
      
      <p className="" id="iyo7r6">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="il8o0q">
        <span>Ingenieria de eventos.</span>
      </span>
      
      </p>
      
      </div>
      
      <div id="id3akf" className="">
      
      <div id="ipwalf" className="">
      
      <img
        className=""
        id="icnrzk"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4vijr82.png"
        alt="undefined"
      />
      
        <a
          target="_blank"
          className="socialMedia "
          id="i9fv9v"
          href="https://www.tiktok.com/@ineven.vip?_t=8sKdB0x1PBG&_r=1"
        >
          
    <div id="il6p1h" className="socialMediaText ">
    
      <span className="" id="iuy85w">
        <span>ineven.vip</span>
      </span>
      
    </div>
    
        </a>
        
      </div>
      
      <div id="izcnyx" className="">
      
      <img
        className=""
        id="i0yhvn"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4bmczdi.png"
        alt="undefined"
      />
      
        <a
          target="_blank"
          className="socialMedia "
          id="i6krqq"
          href="https://www.facebook.com/ineven.vip"
        >
          
    <div id="ixj89k" className="socialMediaText ">
    
      <span className="" id="i07ttm">
        <span>ineven.vip</span>
      </span>
      
    </div>
    
        </a>
        
      </div>
      
      <div id="igk236" className="">
      
      <img
        className=""
        id="i9z0pd"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4bmd43v.png"
        alt="undefined"
      />
      
        <a
          target="_blank"
          className="socialMedia "
          id="irbfgl"
          href="https://www.instagram.com/ineven.vip?igsh=b25xZHA5MDVqaDVp"
        >
          
    <div id="ialqya" className="socialMediaText ">
    
      <span className="" id="iodmkn">
        <span>@ineven.vip</span>
      </span>
      
    </div>
    
        </a>
        
      </div>
      
      <div id="io5w49" className="">
      
      <img
        className=""
        id="i6uigw"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4viijg2.png"
        alt="undefined"
      />
      
        <a
          target="_blank"
          className="socialMedia "
          id="irfhci"
          href="https://www.linkedin.com/company/ineven/"
        >
          
    <div id="iaexq9" className="socialMediaText ">
    
      <span className="" id="i4dl3r">
        <span>ineven.vip</span>
      </span>
      
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      <div id="i1rlot" className="">
      
      <p className="" id="iw7za7">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ic71jf">
        
      <a
        target=""
        className=""
        id="idc4s2"
        href="/sobrenosotros"
        type=""
      >
        <span>Sobre nosotros</span>
      </a>
      
      </span>
      
      </p>
      
      <p className="" id="i3340b">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ih08ak">
        
      <a
        target=""
        className=""
        id="iyp45s"
        href="/servicios"
        type=""
      >
        <span>Nuestros servicios</span>
      </a>
      
      </span>
      
      </p>
      
      <p className="" id="ijqtal">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="itkfgw">
        
      <a
        target=""
        className=""
        id="ia7zw7"
        href="/contrata"
        type=""
      >
        <span>Hazlo tú mismo</span>
      </a>
      
      </span>
      
      </p>
      
      <p className="" id="ik2e3t">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="it8v73">
        
      <a
        target=""
        className=""
        id="ibrnvu"
        href="/proveedores"
        type=""
      >
        <span>Testimonio</span>
      </a>
      
      </span>
      
      </p>
      
      <p className="" id="i38bqt">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ib7tnq">
        
      <a
        target=""
        className=""
        id="i4hvoi"
        href="/contacto"
        type=""
      >
        <span>Contáctanos</span>
      </a>
      
      </span>
      
      </p>
      
      </div>
      
      <div id="ipuzkj" className="">
      
      <p className="" id="ifh7p5">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ita68z">
        <span>+504 9574-8270</span>
      </span>
      
      </p>
      
      <p className="" id="i78qcc">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="imjhna">
        <span>Col. Colonia, 7 calle, 8 avenida S.O</span>
      </span>
      
      </p>
      
      <p className="" id="il1rnw">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i6f3bu">
        <span>ingenierodeevento@gmail.com</span>
      </span>
      
      </p>
      
      </div>
      
      </div>
      
      <div id="iou1pv" className="">
      
      <p className="" id="izq2dp">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ieap6m">
        <span>Todos los derechos reservados - Ineven - 2022 </span>
      </span>
      
      </p>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Phomepageinevenj9lfi);
  